export const GIT_VERBS = {
  LIST: { done: "Listed", running: "Listing", failed: "Could not list" },
  CLONE: { done: "Cloned", running: "Cloning", failed: "Could not clone" },
  SWITCH: {
    done: "Switched to",
    running: "Switching to",
    failed: "Could not switch to",
  },
  FETCH: { done: "Fetched", running: "Fetching", failed: "Could not fetch" },
  CREATE: { done: "Created", running: "Creating", failed: "Could not create" },
  SET_UP: {
    done: "Set up",
    running: "Setting up",
    failed: "Could not set up",
  },
  COMMIT: {
    done: "Committed",
    running: "Committing",
    failed: "Could not commit",
  },
  PUSH: { done: "Pushed", running: "Pushing", failed: "Could not push" },
  OPEN: { done: "Opened", running: "Opening", failed: "Could not open" },
  SUBMIT: {
    done: "Submitted",
    running: "Submitting",
    failed: "Could not submit",
  },
  RESTACK: {
    done: "Restacked",
    running: "Restacking",
    failed: "Could not restack",
  },
  CONTINUE_RESTACK: {
    done: "Continued restacking",
    running: "Continuing to restack",
    failed: "Could not continue restacking",
  },
  REVIEW: {
    done: "Reviewed",
    running: "Reviewing",
    failed: "Could not review",
  },
  COMMENT: {
    done: "Commented",
    running: "Commenting",
    failed: "Could not comment",
  },
  REPLY: { done: "Replied", running: "Replying", failed: "Could not reply" },
  RESOLVE: {
    done: "Resolved",
    running: "Resolving",
    failed: "Could not resolve",
  },
  ASK_MERGE: {
    done: "Asked to merge",
    running: "Asking to merge",
    failed: "Could not ask to merge",
  },
  ASK_DEPLOY: {
    done: "Asked to deploy",
    running: "Asking to deploy",
    failed: "Could not ask to deploy",
  },
} as const;
